// preloader js
window.addEventListener('load', function () {
  const preloader = document.getElementById('global-preloader');
  if (!preloader) return;

  preloader.classList.add('is-hidden');

  preloader.addEventListener(
    'transitionend',
    () => {
      preloader.style.display = 'none';
    },
    { once: true }
  );
});

// pagination js load more btn
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("#load-more");
  if (!btn) return;

  
  const productGrid = document.querySelector("#product-grid");
  const articleGrid = document.querySelector("#article-grid");

  const grid = productGrid || articleGrid;
  if (!grid) return;

 
  const itemSelector = productGrid
    ? "#product-grid > li"
    : "#article-grid > .blog-articles__article";

  btn.addEventListener("click", () => {
    btn.textContent = "Loading...";

    fetch(btn.dataset.nextUrl)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        doc.querySelectorAll(itemSelector).forEach(item => {
          grid.appendChild(item);
        });

        const nextBtn = doc.querySelector("#load-more");

        if (nextBtn) {
          btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
          btn.textContent = "Load More";
        } else {
          btn.remove();
        }
      })
      .catch(() => {
        btn.textContent = "Load More";
      });
  });
});






